import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "order-list" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "mypage-title -bold" }, "order-list", -1)
const _hoisted_3 = { class: "order-list--table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")
  const _component_DateNameFilter = _resolveComponent("DateNameFilter")
  const _component_Orders = _resolveComponent("Orders")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_BackButton),
    _createVNode("section", _hoisted_3, [
      _createVNode(_component_DateNameFilter, {
        class: "request-list__filter",
        filterState: _ctx.filterState,
        onOnSearch: _ctx.onSearch
      }, null, 8, ["filterState", "onOnSearch"]),
      _createVNode(_component_Orders, {
        list: _ctx.state.list
      }, null, 8, ["list"])
    ])
  ]))
}